// extracted by mini-css-extract-plugin
export default {"loginPage":"Login_loginPage__rnzbS","card":"Login_card__8+qxP","cardContent":"Login_cardContent__hKuXR"};